import type { WorkOrderTransitionView } from '@chukua/common';

/**
 * Mirrors the API's verifier-eligibility.policy.ts so the form can say up front that a second person must verify.
 * The web cannot see who logged labour, so that refusal still comes back from the server and is shown inline.
 */
export function verifierRefusal({
  currentUserId,
  raisedById,
  transitions,
}: {
  currentUserId: string;
  raisedById: string;
  transitions: WorkOrderTransitionView[];
}): string | null {
  if (currentUserId === raisedById) return 'You raised this work order, so someone else has to verify it.';
  const worked = transitions.some(
    (t) => t.actorId === currentUserId && (t.toState === 'completed' || (t.fromState === 'scheduled' && t.toState === 'in_progress')),
  );
  return worked ? 'You worked on this work order, so someone else has to verify it.' : null;
}
